import { defineMessages } from "react-intl";

const messages = defineMessages({
    start: {
        id: "task.embed.startTime",
    },
    end: {
        id: "task.embed.endTime",
    },
});

export default messages;
